import { useState, useEffect } from 'react';

const FAVORITES_KEY = 'weather-world-favorites';

export const useFavorites = () => {
  const [favorites, setFavorites] = useState([]);

  // Load favorites from localStorage on mount
  useEffect(() => {
    const savedFavorites = localStorage.getItem(FAVORITES_KEY);
    if (savedFavorites) {
      try {
        setFavorites(JSON.parse(savedFavorites));
      } catch (error) {
        console.error('Error loading favorites:', error);
        setFavorites([]);
      }
    }
  }, []);

  // Save favorites to localStorage whenever favorites change
  useEffect(() => {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
  }, [favorites]);

  const addFavorite = (location) => {
    const favorite = {
      id: `${location.latitude}-${location.longitude}`,
      name: location.name,
      country: location.country,
      latitude: location.latitude,
      longitude: location.longitude,
      displayName: location.displayName,
      addedAt: new Date().toISOString()
    };

    setFavorites(prev => {
      // Check if already exists
      const exists = prev.some(fav => fav.id === favorite.id);
      if (exists) {
        return prev;
      }
      return [...prev, favorite];
    });
  };

  const removeFavorite = (favoriteId) => {
    setFavorites(prev => prev.filter(fav => fav.id !== favoriteId));
  };

  const isFavorite = (latitude, longitude) => {
    const id = `${latitude}-${longitude}`;
    return favorites.some(fav => fav.id === id);
  };

  const clearAllFavorites = () => {
    setFavorites([]);
  };

  return {
    favorites,
    addFavorite,
    removeFavorite,
    isFavorite,
    clearAllFavorites
  };
};
